<div class="w-100 d-flex justify-content-between py-6">
  <hr class="w-100">
  <h1 class="w-25 text-center" translate>search.ressources</h1>
  <hr class="w-100">
</div>
<div class="d-flex flex-wrap justify-content-center gap-8">
  <div *ngFor="let resource of data$ | async as data" class="ressource-card-body bg-white py-2 px-0 d-flex flex-column ">
    <a [routerLink]="'/player/'+resource?.slug" class="align-self-center" target="_blank">
      <div
      class="media custom-image cursor-pointer " 
      [style.backgroundImage]="'url(' + resource?.thumbnail + ')'"
      >
    </div>
    </a>  
      <!-- <h3 class=" text-center pt-4 cursor-pointer " *ngIf="resource.highlight?.key === 'title'" [innerHTML]="resource.highlight?.value"></h3> -->
      <h3 class="title-line text-center pt-4 cursor-pointer " *ngIf="!getKeys(resource.highlights).includes('title')" >{{resource?.title}}</h3>
      <h3 class="title-line text-center pt-4 cursor-pointer highlighted" *ngIf="getKeys(resource.highlights).includes('title')" [innerHTML]="resource.highlights?.title" ></h3>
        <ng-container *ngIf="showDetails">
          <p class="text-muted fs-6 px-2"  *ngIf="!getKeys(resource.highlights).includes('description')">  {{resource?.description ? resource?.description : 'search.no_description' | translate }}</p>
          <p class="text-muted fs-6 px-2 highlighted" *ngIf="getKeys(resource.highlights).includes('description')" [innerHTML]="resource.highlights?.description"></p>
          <ng-container *ngIf="resource?._type==='screen'">
          <p class="fw-bolder fs-6 px-3 m-0 mb-1">{{resource?.screen_title}}</p>
            <p  class="highlighted px-1 content" *ngIf="getKeys(resource.highlights).includes('content')" [innerHTML]="resource.highlights?.content"></p>
          </ng-container>
        </ng-container>
  </div>
</div>


